var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-question",
    clipPath: "url(#clip0_2412_16402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 0H4C1.794 0 0 1.794 0 4V16C0 18.206 1.794 20 4 20H6.923L10.672 23.156C11.054 23.496 11.533 23.665 12.009 23.664C12.477 23.664 12.94 23.502 13.301 23.18L17.148 20H20.001C22.207 20 24.001 18.206 24.001 16V4C24.001 1.794 22.206 0 20 0ZM22 16C22 17.103 21.103 18 20 18H16.788C16.556 18 16.33 18.081 16.151 18.229L11.98 21.644L7.932 18.235C7.751 18.083 7.523 18 7.287 18H3.999C2.896 18 1.999 17.103 1.999 16V4C1.999 2.897 2.896 2 3.999 2H19.999C21.102 2 21.999 2.897 21.999 4L22 16ZM13.5 16.5C13.5 17.328 12.828 18 12 18C11.172 18 10.5 17.328 10.5 16.5C10.5 15.672 11.172 15 12 15C12.828 15 13.5 15.672 13.5 16.5ZM15.864 6.951C16.354 8.849 15.435 10.818 13.678 11.631C13.439 11.742 12.999 12.271 12.999 12.8V13C12.999 13.553 12.552 14 11.999 14C11.446 14 10.999 13.553 10.999 13V12.8C10.999 11.416 11.946 10.23 12.837 9.817C13.569 9.478 14.222 8.593 13.928 7.452C13.758 6.796 13.204 6.242 12.549 6.073C11.906 5.904 11.278 6.03 10.777 6.418C10.283 6.801 10 7.378 10 8.001C10 8.554 9.553 9.001 9 9.001C8.447 9.001 8 8.554 8 8.001C8 6.754 8.565 5.601 9.553 4.837C10.539 4.071 11.815 3.815 13.05 4.137C14.408 4.487 15.514 5.591 15.864 6.951Z",
    fill: "#1F8475"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2412_16402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageQuestion);
export default __webpack_public_path__ + "static/media/message-question.870edb30778263c898c5e889332034ee.svg";
export { ForwardRef as ReactComponent };